import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./pricingSummary.html";
import { schemas } from '@oneappexchange/oaf-schema';
import { getPlanPrice, getPlanUnits, hasDiscountNonProfits, isFreemiumListing, isFreeToInstallListing, isLowestStartingPrice, isPaidListing } from '~/modules/helpers/pricingHelper';
import { Routes } from '~/modules/routes';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { buildFrequencyLabels } from '~/modules/utilities/pricingUtilities';
import { upsertQueryParams } from '~/modules/utilities/router';
class PricingSummary extends LightningElement {
  constructor(...args) {
    super(...args);
    this.pricing = void 0;
  }
  i18nCallback(i18n) {
    this.staticLabels = i18n.listingDetails.pricing;
    this.frequencyLabels = buildFrequencyLabels(this.staticLabels);
  }
  get pricingDetailsUrlLabel() {
    return i18nStore.getState().i18n.listingDetails.pricing.pricingDetailsURL({
      URL: `${Routes.LISTING}?${upsertQueryParams(['tab', 'e'], ['scrollTo', 'pricing-details'])}`
    });
  }

  // PRICING DATA FROM OAF
  get defaultPricingPlan() {
    if (this.pricing?.model?.plans) {
      const plans = [...this.pricing.model.plans];
      plans.sort((a, b) => a.index - b.index);
      return plans[0];
    }
    return schemas['pricing_plan/pricing/PricePlan'].new();
  }
  get defaultPlanCurrencyCode() {
    return this.defaultPricingPlan.currency_code;
  }
  get defaultPlanUnit() {
    return this.defaultPricingPlan.units;
  }
  get defaultPlanPrice() {
    return this.defaultPricingPlan.price;
  }
  get defaultPlanFrequency() {
    // @ts-expect-error * Automated Type Error Fix
    return this.frequencyLabels[this.defaultPricingPlan.frequency] ?? '';
  }
  get summaryHeadline() {
    if (isPaidListing(this.pricing)) {
      if (this.pricing?.model?.plans?.length === 0) {
        return this.staticLabels.paidListing;
      }
      const price = getPlanPrice(this.defaultPlanCurrencyCode, this.defaultPlanPrice);
      return isLowestStartingPrice(this.defaultPricingPlan) ? i18nStore.getState().i18n.listingDetails.pricing.startingAt({
        PRICE: price
      }) : price;
    }
    if (isFreeToInstallListing(this.pricing)) {
      return this.staticLabels.freeToInstallSubSectionHeader;
    }
    if (isFreemiumListing(this.pricing)) {
      return this.staticLabels.freemiumSubSectionHeader;
    }
    return this.staticLabels.freeSummaryHeadline;
  }
  get summaryHeadlinePaidPlanDetails() {
    // @ts-expect-error * Automated Type Error Fix
    if (isPaidListing(this.pricing) && this.pricing.model?.plans?.length > 0) {
      return `${this.defaultPlanCurrencyCode}/${getPlanUnits(this.defaultPricingPlan)}/${this.defaultPlanFrequency}`;
    }
    return '';
  }
  get summaryDescription() {
    if (hasDiscountNonProfits(this.pricing)) {
      if (isPaidListing(this.pricing)) {
        return this.staticLabels.summaryDescriptionNonProfits;
      }
      if (isFreeToInstallListing(this.pricing)) {
        return this.staticLabels.freeToInstallSummaryforNonProfitHeadline;
      }
      if (isFreemiumListing(this.pricing)) {
        return this.staticLabels.freemiumNonProfitSummaryDescription;
      }
    }
    if (isPaidListing(this.pricing)) {
      return '';
    }
    if (isFreeToInstallListing(this.pricing)) {
      return this.staticLabels.freeToInstallSummaryDescription;
    }
    if (isFreemiumListing(this.pricing)) {
      return this.staticLabels.freemiumSummaryDescription;
    }
    return this.staticLabels.freeSummaryDescription;
  }
  get paidDescriptionText() {
    return `${this.defaultPlanCurrencyCode}/${this.defaultPlanUnit}/${this.defaultPlanFrequency}`;
  }
  handleI18nLinkClick() {
    const analyticsEvent = new CustomEvent('linkclick');
    this.dispatchEvent(analyticsEvent);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(PricingSummary, {
  publicProps: {
    pricing: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(PricingSummary, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;